import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="30px" column justifyStart>
          <CFView h3 futura bold color="#BAA286" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Kita-No-Donburi-147344886066926/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Kita no donburi Bar Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Kita no donburi Bar Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#BAA286" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Kita-No-Donburi-147344886066926/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Kita no donburi Bar Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Kita no donburi Bar Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
